import { createVanIconComponent } from "./van"

const ThumbCircle = createVanIconComponent("thumb-circle")
export default ThumbCircle
